import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import useAuth from 'auth/useAuth';
import FullscreenProgress from './FullScreenProgress';
import SignUserAgreementDialog from 'containers/Agreement/SignUserAgreementDialog';
import type { RootState } from 'store';
import { getIsOnline } from 'store/connection/selectors';

interface AppStartupProps {
  children: React.ReactNode;
}

const AppStartup = ({ children }: AppStartupProps) => {
  const { login, isAuthenticated, isInitialized } = useAuth();
  const isOnline = useSelector(getIsOnline);
  const { isApproved: isAgreementsApproved } = useSelector(
    (state: RootState) => state.agreement,
  );

  // Login once keycloak is initialized and user it not authenticated
  useEffect(() => {
    if (isInitialized && !isAuthenticated && isOnline) {
      login();
    }
  }, [isInitialized, isAuthenticated, isOnline, login]);

  if (!isAuthenticated && isOnline) {
    return <FullscreenProgress isVisible />;
  }

  if (!isAgreementsApproved && isOnline) {
    return <SignUserAgreementDialog />;
  }

  return <>{children}</>;
};

export default AppStartup;
